"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertySchema = void 0;
exports.propertySchema = {
    type: ['object', 'null'],
    required: [
        'cmhcAccountNumber',
        'additionalAddressStreetNumber',
        'currentCmhcOfficeID',
        'dwellingTypeCode',
        'federalConstituencyID',
        'marketAreaGeographicalTypeCode',
        'metropolitanMajorAreaID',
        'previousCmhcOfficeID',
        'propertyAddressMunicipalityName',
        'propertyAddressPostalCode',
        'propertyAddressStreetDirectionID',
        'propertyAddressStreetName',
        'propertyAddressStreetNumber',
        'propertyAddressStreetTypeID',
        'propertyAddressUnitNumber',
        'propertyLocationLegalDescriptionEnglish',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'standardGeographicalLocationID',
        'tenureTypeCode',
        'totalBedCount',
        'totalUnitCount',
        'urbanRuralID',
        'validatedAddressResultTypeCode',
        'validatedPropertyAddressMunicipalityName',
        'validatedPropertyAddressPostalCode',
        'validatedPropertyAddressStreetDirectionID',
        'validatedPropertyAddressStreetName',
        'validatedPropertyAddressStreetNumber',
        'validatedPropertyAddressStreetTypeID',
        'validatedPropertyAddressUnitNumber',
        'validatedProvinceID',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'number',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be an integer between 0 and 999999999999',
        },
        additionalAddressStreetNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters',
        },
        currentCmhcOfficeID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        dwellingTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        federalConstituencyID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        marketAreaGeographicalTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        metropolitanMajorAreaID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        municipalityName: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        previousCmhcOfficeID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        propertyAddressMunicipalityName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        propertyAddressPostalCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyAddressStreetDirectionID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertyAddressStreetName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters',
        },
        propertyAddressStreetNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        propertyAddressStreetTypeID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        propertyAddressUnitNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyLocationLegalDescriptionEnglish: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 60,
            errorMessage: 'should have variable length up to 60 characters',
        },
        propertySaleAssessmentID: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        standardGeographicalLocationID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        tenureTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        totalBedCount: {
            type: 'integer',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be an integer with up to 5 digits in total',
        },
        totalUnitCount: {
            type: 'integer',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be an integer with up to 5 digits in total',
        },
        urbanRuralID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        validatedAddressResultTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedPropertyAddressMunicipalityName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        validatedPropertyAddressPostalCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedPropertyAddressStreetDirectionID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedPropertyAddressStreetName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters',
        },
        validatedPropertyAddressStreetNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        validatedPropertyAddressStreetTypeID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedPropertyAddressUnitNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedProvinceID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
    },
};
exports.default = exports.propertySchema;
